'use client';

import { productDetailPayloadToBaseCarData } from '@/data/ProductApi/ProductDetailPayloadToBaseCarData';
import { Carousel } from '@/general/components/Carousel/Carousel';
import { ProductCard } from '@/general/components/ProductCard/ProductCard';
import { pushCarmaRecommendationEvent } from '@/general/helpers/pushCarmaRecommendationEvent';
import { ProductListDataPayload, ProductListDataRow } from '@/types/CataloguePage.types';
import { pushToDataLayerProductCard } from '@/utils/pushToDataLayerProductCard';
import { ComponentProps, FC } from 'react';

interface SimilarCarsCarouselContentProps {
  results: ProductListDataPayload['results'];
  recommendationId: string | null;
}

const carouselName = 'similar-cars-carousel';

export const SimilarCarsCarouselContent: FC<SimilarCarsCarouselContentProps> = ({ results, recommendationId }) => {
  const onCardClick = (product: ProductListDataRow) => {
    // Send an event to the miniCDP to capture the recommendation id and the SKU displayed
    pushCarmaRecommendationEvent('similar', results, recommendationId)(product.sku);
  };

  const tiles = generateTiles(results, onCardClick);

  return <Carousel tiles={tiles} />;
};

const generateTiles = (
  results: ProductListDataPayload['results'],
  onCardClick: (product: ProductListDataRow, index: number) => void,
): ComponentProps<typeof Carousel>['tiles'] => {
  const tiles = results.map((product, index) => ({
    id: product.sku,
    tile: (
      <ProductCard
        carData={productDetailPayloadToBaseCarData(product)}
        weeklyRepayment={product.weeklyRepayment}
        defaultRate={product.defaultRate}
        variant="default"
        onCardClick={() => {
          pushToDataLayerProductCard(product, index, {
            event: 'carousel_tile_click',
            name: carouselName,
            value: carouselName,
            variant: 'plp',
          });
          onCardClick(product, index);
        }}
      />
    ),
  }));

  return tiles;
};
